export const round = (value) => {
  return parseFloat(value).toFixed(2)
}

export const PackageDimensions = ({ dimensions }) => {
  const { height, length, unit, width } = dimensions
  return `${round(width)}(W) * ${round(height)}(H) * ${round(length)}(L) ${unit} (approx)`
}

export const filterVariation = (id, variations) => {
  return variations.filter((variation) => variation.id === id).pop()
}

export const filterVariationAttributes = (variations) => {
  if (variations.length === 0) return []

  return variations.map(({ relationships }) => {
    if (!relationships) return {}
    return Object.fromEntries(Object.entries(relationships).filter(([name, value]) => {
      if (name === 'attribute_size1' || name === 'attribute_size2') {
        if (value && value.name === '0') return false
      }

      return name.startsWith('attribute_') && value
    }))
  })
}

export const createAttributesMap = (attributes, display, results) => {
  const attributeSingleValue = {}
  for (let index = 0; index < results.length; index++) {
    if (!attributeSingleValue[results[index].name]) {
      attributeSingleValue[results[index].name] = true

      if (results[index].options.length <= 1) {
        attributeSingleValue[results[index].name] = false
      }
    }
  }

  return attributes.map((attribute) => {
    const results = []

    for (let [attribute_name, value] of Object.entries(attribute)) {
      if (display[attribute_name] && display[attribute_name].hasOwnProperty('display') &&
          display[attribute_name].display === 1) {
        continue
      }
      if (!attributeSingleValue[attribute_name]) {
        continue
      }

      if (value) {
        results.push({
          name: attribute_name,
          value: value.id
        })
      }
    }

    return results
  })
}

export const createVariationAttributesMap = (variations, attributes) => {
  const variationIds = variations.map(value => value.id)

  return attributes.map((attribute, index) => {
    const results = []

    for (let [, value] of Object.entries(attribute)) {
      if (value) {
        results.push(value.id)
      }
    }

    return {
      id: variationIds[index],
      values: results
    }
  })
}

export const createAttributeOptions = (attributes) => {
  const results = {}

  for (let index = 0; index < attributes.length; index++) {
    const attribute = attributes[index]

    for (let [key, value] of Object.entries(attribute)) {
      if (!results.hasOwnProperty(key) && value) {
        results[key] = [value]
      }
      else if (value) {
        const hasValue = results[key].find(result => result.id == value.id)
        if (!hasValue) results[key].push(value)
      }

      results[key].sort((a, b) => a.field_value - b.field_value)
    }
  }

  return results
}